// components/payments/PaymentStatsCards.tsx
import React from "react";
import { Clock, TrendingUp, AlertTriangle } from "lucide-react";

interface PaymentStats {
  availableBalance: number;
  pendingAmount: number;
  totalEarned: number;
  payoutFailures: number;
  pendingTransactions: number;
  failedPayouts: number;
}

interface PaymentStatsCardsProps {
  stats: PaymentStats;
}

const PaymentStatsCards: React.FC<PaymentStatsCardsProps> = ({ stats }) => {
  const cards = [
    // {
    //   id: 1,
    //   label: "Available Balance",
    //   value: `$${stats.availableBalance.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
    //   subtext: "Ready to withdraw",
    //   icon: DollarSign,
    //   gradient: "from-emerald-500 to-teal-500",
    //   bgGlow: "bg-emerald-500/10",
    // },
    {
      id: 2,
      label: "Pending Earnings",
      value: `$${stats.pendingAmount.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      subtext: `To be paid during the next payment cycle`,
      icon: Clock,
      gradient: "from-yellow-600 to-orange-400",
      bgGlow: "bg-yellow-500/10",
    },
    {
      id: 3,
      label: "Total Earned",
      value: `$${stats.totalEarned.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      subtext: "Lifetime earnings",
      icon: TrendingUp,
      gradient: "from-blue-500 to-indigo-500",
      bgGlow: "bg-blue-500/10",
    },
    {
      id: 4,
      label: "Payout Failures",
      value: `$${stats.payoutFailures.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      subtext: `${stats.failedPayouts} failed payouts`,
      icon: AlertTriangle,
      gradient:
        stats.failedPayouts > 0
          ? "from-red-500 to-rose-500"
          : "from-gray-400 to-gray-500",
      bgGlow: stats.failedPayouts > 0 ? "bg-red-500/10" : "bg-gray-500/10",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.id}
          className="relative bg-white rounded-2xl p-5 border border-gray-100 shadow-sm overflow-hidden group hover:shadow-md transition-shadow"
        >
          {/* Background Glow */}
          <div
            className={`absolute -top-10 -right-10 w-32 h-32 ${card.bgGlow} rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity`}
          />

          <div className="relative">
            <div className="flex items-center justify-between mb-4">
              <div
                className={`w-12 h-12 rounded-xl bg-gradient-to-br ${card.gradient} flex items-center justify-center shadow-lg`}
              >
                <card.icon className="w-6 h-6 text-white" />
              </div>
            </div>
            <p className="text-2xl font-bold text-gray-900">{card.value}</p>
            <p className="text-sm font-medium text-gray-500 mt-1">
              {card.label}
            </p>
            <p className="text-xs text-gray-400 mt-0.5">{card.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentStatsCards;
